'use client';

import { usePathname } from 'next/navigation';

type HeaderPageCopyProps = {
    homePath: string;
    homeTitle: string;
};

export default function HeaderPageCopy({ homePath, homeTitle }: HeaderPageCopyProps) {
    const pathname = usePathname();
    const [firstLine, ...remainingLines] = homeTitle.split('\n');
    const secondLine = remainingLines.join(' ').trim();
    const [emphasis, ...secondLineRest] = secondLine.split(/\s+/);
    const titleContent = (
        <>
            <span className='site-header__home-title-line'>{firstLine}</span>
            {secondLine && (
                <>
                    {' '}
                    <span className='site-header__home-title-line'>
                        <em className='site-header__home-title-emphasis'>{emphasis}</em>
                        {secondLineRest.length > 0 ? ` ${secondLineRest.join(' ')}` : ''}
                    </span>
                </>
            )}
        </>
    );

    return pathname === homePath ? (
        <h1 className='site-header__home-title site-header__home-title--primary'>{titleContent}</h1>
    ) : (
        <div className='site-header__home-title site-header__home-title--secondary'>
            {titleContent}
        </div>
    );
}
